export enum BottomPanePositionsEnum {
  TOP = 'top',
  MIDDLE = 'middle',
  BOTTOM = 'bottom',
}
